module.exports = __webpack_public_path__ + "img/subject_banner9.e78a451a.png";